import { fetchAllPrompts, savePrompt } from "./AIPrompts/thunk";
import {
  activateDeactivateHumanCategory,
  activateDeactivateRoles,
  activateDeactivateUser,
  AddAIResponse,
  addHumanCategory,
  addNewTag,
  CheckUserExistence,
  createCategory,
  createLocalization,
  createRole,
  createScreen,
  createUser,
  deleteCategory,
  deleteChatSession,
  deleteDocuments,
  deleteHumanCategory,
  deleteLocalization,
  deleteRole,
  deleteScreen,
  deleteUser,
  editChatSessionTitle,
  fetchAllCategories,
  fetchAllDocument,
  fetchAllPages,
  fetchAllRoles,
  fetchAllTags,
  fetchCategories,
  fetchCategoryTableColumnNames,
  fetchChatReport,
  fetchChatReportTableColumnNames,
  fetchDocumentTableColumnNames,
  fetchHumanCategories,
  fetchHumanCategoriesTableColumnNames,
  fetchLocalization,
  fetchLocalizationTableColumnNames,
  fetchLogs,
  fetchLogsTableColumnNames,
  fetchPageTableColumnNames,
  fetchParentCategories,
  fetchRoles,
  fetchRoleTableColumnNames,
  fetchScreens,
  fetchScreenTableColumnNames,
  fetchSubCategories,
  fetchUserModule,
  fetchUsers,
  fetchUsersTableColumnNames,
  getAIResponse,
  getChatHistory,
  getChatSessionHistory,
  getDocumentsType,
  likeDislikeMessage,
  saveDocumentMetadata,
  updateCategories,
  updateHumanCategory,
  updateLocalization,
  updatePagePermission,
  updateRoles,
  updateScreen,
  updateUser,
  updateUserPreference,
  uploadCategoryIcon,
  uploadDocumentFile,
  uploadImageFile,
  updateDocumentJson,
  retryDocument,
  uploadCaseFile,
  fetchCaseTableColumnNames,
  fetchAllCases,
  addCase,
  updateCase, 
  deleteCases,
  fetchAllCaseTypes,
  fetchReportedTableColumnNames,
  fetchUserReportedIssues,
  deleteReportedIssues,
  fetchReportedIssuesClientUsers,
  updateReportedIssueStatus
} from "./thunks";

// Add all your async thunks here
export const thunkRegistry = {
  "module/fetchUserModule": fetchUserModule,
  "localization/updatePreference": updateUserPreference,

  // Administration
  "screen/fetchTableColumnNames": fetchScreenTableColumnNames,
  "screens/fetch": fetchScreens,
  "screen/add": createScreen,
  "screen/update": updateScreen,
  "screen/delete": deleteScreen,

  "localization/fetchTableColumnNames": fetchLocalizationTableColumnNames,
  "localization/fetch": fetchLocalization,
  "localization/add": createLocalization,
  "localization/update": updateLocalization,
  "localization/delete": deleteLocalization,

  "alitqanCms/fetchTableColumnNames": fetchLocalizationTableColumnNames,
  "alitqanCms/fetch": fetchLocalization,
  "alitqanCms/add": createLocalization,
  "alitqanCms/update": updateLocalization,
  "alitqanCms/delete": deleteLocalization,

  "logs/fetchTableColumnNames": fetchLogsTableColumnNames,
  "logs/fetch": fetchLogs,

  "users/fetchUsersTableColumnNames": fetchUsersTableColumnNames,
  "users/fetchUsers": fetchUsers,
  "user/addUser": createUser,
  "user/updateUser": updateUser,
  "user/deleteUser": deleteUser,
  "user/toggleStatus": activateDeactivateUser,
  "roles/fetch": fetchRoles,
  "users/checkUserExistence": CheckUserExistence,

  "roles/fetchTableColumnNames": fetchRoleTableColumnNames,
  "roles/fetchAll": fetchAllRoles,
  "roles/add": createRole,
  "roles/update": updateRoles,
  "roles/delete": deleteRole,
  "roles/active": activateDeactivateRoles,
  "permission/fetchPermissionTableColumnNames": fetchPageTableColumnNames,
  "permission/fetchAllPages": fetchAllPages,
  "page/updatePagePermission": updatePagePermission,

  "humanCategories/uploadImageFile": uploadCategoryIcon,
  "humanCategories/fetchHumanCategoriesTableColumnNames": fetchHumanCategoriesTableColumnNames,
  "humanCategories/fetch": fetchHumanCategories,
  "humanCategories/add": addHumanCategory,
  "humanCategories/update": updateHumanCategory,
  "humanCategories/delete": deleteHumanCategory,
  "humanCategories/activateDeactivate": activateDeactivateHumanCategory,

  "chatReport/fetchChatReportTableColumnNames": fetchChatReportTableColumnNames,
  "chatReport/fetch": fetchChatReport,

  // AI
  "aiChat/addAIResponse": AddAIResponse,
  "aiChat/getChatSessionHistory": getChatSessionHistory,
  "aiChat/getChatHistory": getChatHistory,
  "aiChat/likeDislikeMessage": likeDislikeMessage,
  "aiChat/editChatSessionTitle": editChatSessionTitle,
  "aiChat/deleteChatSession": deleteChatSession,
  "aiDoc/fetchTableColumnNames": fetchDocumentTableColumnNames,
  "aiDoc/uploadDocumentFile": uploadDocumentFile,
  "aiDoc/uploadImageFile": uploadImageFile,
  "aiDoc/fetchCategories": fetchCategories,
  "aiDoc/fetchAllTags": fetchAllTags,
  "aiDoc/fetchAllDocument": fetchAllDocument,
  "aiDoc/updateDocumentJson": updateDocumentJson,
  "aiDoc/saveDocumentMetadata": saveDocumentMetadata,
  "aiDoc/retryDocument": retryDocument,
  "aiDoc/deleteDocuments": deleteDocuments,
  "categories/fetchTableColumnNames": fetchCategoryTableColumnNames,
  "categories/fetchAll": fetchAllCategories,
  "categories/add": createCategory,
  "categories/update": updateCategories,
  "categories/delete": deleteCategory,
  "categories/active": updateCategories,
  "categories/fetchParentCategories": fetchParentCategories,
  "categories/getDocumentsType": getDocumentsType,
  "AIPrompt/fetchAll": fetchAllPrompts,
  "AIPrompt/save": savePrompt,
  "categories/fetchSubCategories": fetchSubCategories,
  "aiDoc/addNewTag": addNewTag,
  "cases/uploadCaseFile": uploadCaseFile,
  "cases/fetchTableColumnNames": fetchCaseTableColumnNames,
  "cases/fetchAll": fetchAllCases,
  "cases/add": addCase,
  "cases/update": updateCase,
  "cases/delete": deleteCases,
  "cases/fetchCaseTypes": fetchAllCaseTypes,

  // Reported Legal Issues
  "reportedLegalIssues/fetchReportedTableColumnNames": fetchReportedTableColumnNames,
  "reportedLegalIssues/fetchUserReportedIssues": fetchUserReportedIssues,
  "reportedLegalIssues/deleteReportedIssues": deleteReportedIssues,
  "reportedLegalIssues/fetchReportedIssuesClientUsers": fetchReportedIssuesClientUsers,
  "reportedLegalIssues/updateReportedIssueStatus": updateReportedIssueStatus,
  
};
